import { State } from './state';

const get = (state: State): State => state;

export {
  // eslint-disable-next-line
  get,
};
